import GlobalStyle from './GlobalStyle';

export default GlobalStyle;
